import { array } from 'yup';
import { InterimCareSummarySupportProgressSchema } from './InterimCareSummarySupportProgressSchema';

// Bug in formik, it does not show formik.errors for arrays
// https://github.com/jaredpalmer/formik/issues/1116
// Use yup validation
export const InterimCareSummarySupportProgressListSchema = array()
  .of(InterimCareSummarySupportProgressSchema)
  .required();
